// PrivateRoute.tsx in v6
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isLoggedIn } from '../../../features/authentication/utils/auth';

const ProtectedRoute = ({ children }) => {
	const location = useLocation();

	if (!isLoggedIn()) {
		return <Navigate to="/login" state={{ from: location }} />;
	}

	return children;
};

ProtectedRoute.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

export default ProtectedRoute;
